import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

interface FilterOption {
	label: string;
}

type FilterSelectorProps = {
	filterList: FilterOption[];
	filterLabel?: string;
	setFilterSelected: (option: string) => void;
};

const FilterSelector = ({
	filterList,
	filterLabel,
	setFilterSelected,
}: FilterSelectorProps) => {
	const handleSelectionChange = (
		_: React.SyntheticEvent,
		value: { label: string } | null,
	) => {
		const option = value ? value.label : '';
		setFilterSelected(option);
	};

	return (
		<Autocomplete
			disablePortal
			id="combo-box-demo"
			options={filterList}
			onChange={handleSelectionChange}
			data-test="filter-selector"
			isOptionEqualToValue={(option, value) => option.label === value.label}
			renderInput={(params) => (
				<TextField
					label={filterLabel ?? 'Filter'}
					{...params}
					sx={{
						width: '180px',
						'& .MuiInputBase-root': {
							height: '36px',
							minHeight: '36px',
							padding: '0 8px',
						},
						'& .MuiAutocomplete-input': {
							padding: '6px 0',
						},
						'& .MuiInputLabel-root': {
							top: '-6px',
						},
					}}
				/>
			)}
		/>
	);
};

export default FilterSelector;
